import React, { useEffect, useRef } from "react";
import { HashRouter } from "react-router-dom";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import Header from "../common/template/header";
import SideBar from "../common/template/sideBar";
import Messages from "../common/msg/messages";
import Routes from "./routes";

import { buscarSessao, validateToken } from "../auth/authActions";
import { getListaClientesUcsFiltradosSelect } from "../fatura/faturaActions";
import { getListaClientesUcsFiltradosSelect as getListaClientesUcsAguaFiltradosSelect } from "../fatura/faturaAguaActions";

function App(props) {
    const intervalId = useRef(null);
    const jaExecutou = useRef(false);
    useEffect(() => {
        props.buscarSessao();
    }, []);

    useEffect(() => {
        if (!props.usuarioLogado || jaExecutou.current) return;
        props.getListaClientesUcsFiltradosSelect({ force: true });
        props.getListaClientesUcsAguaFiltradosSelect({ force: true });
        jaExecutou.current = true;
    }, [props.usuarioLogado]);

    useEffect(() => {
        if (!props.usuarioLogado) return;
        props.getListaClientesUcsFiltradosSelect({ force: true });
        props.getListaClientesUcsAguaFiltradosSelect({ force: true });
    }, [props.idEmpresaDashboard]);

    // componentDidMount + componentWillUnmount
    useEffect(() => {
        props.validateToken({ token: props.usuario.token });

        // Intervalo a cada 5 minutos
        intervalId.current = setInterval(() => {
            props.validateToken({ token: props.usuario.token });
            props.getListaClientesUcsFiltradosSelect({ force: true });
            props.getListaClientesUcsAguaFiltradosSelect({ force: true });
        }, 300000);

        console.log("Definiu intervalo de atualização token", intervalId.current);

        return () => {
            if (intervalId.current) {
                clearInterval(intervalId.current);
                console.log("Limpou o intervalo de atualização de token");
                intervalId.current = null;
            }
        };
    }, [props.usuario.token]);

    return (
        <HashRouter>
            <div className="wrapper">
                <Header />
                <SideBar sessao={props.usuarioLogado} />
                <Routes sessao={props.usuarioLogado} />
                <Messages />
            </div>
        </HashRouter>
    );
}

const mapStateToProps = (state) => ({
    usuario: state.auth.usuario,
    usuarioLogado: state.auth.usuarioLogado,
    idEmpresaDashboard: state.dashboard.filtro.id_empresa,
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            buscarSessao,
            validateToken,
            getListaClientesUcsFiltradosSelect,
            getListaClientesUcsAguaFiltradosSelect,
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(App);
